var vgTmp = window.VG;

window.VG = function(node)
{
	if (window.VG.type.isNotEmptyString(node))
	{
		return document.getElementById(node);
	}

	if (window.VG.type.isDomNode(node))
	{
		return node;
	}

	return null;
};

if (vgTmp)
{
	Object.keys(vgTmp).forEach((key) => {
		window.VG[key] = vgTmp[key];
	});
}

exports = window.VG;